import { render } from "./subpartA04.vue?vue&type=template&id=fdb43f3c&scoped=true"
import script from "./subpartA04.vue?vue&type=script&lang=js"
export * from "./subpartA04.vue?vue&type=script&lang=js"

import "./subpartA04.vue?vue&type=style&index=0&id=fdb43f3c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdb43f3c"]])

export default __exports__